/**
 * Lazy-loads the large PDF viewer dependencies to reduce the application's initial JavaScript download.
 *
 * React-PDF's Document and Page must share this lazy boundary to prevent the first PDF display
 * from failing in React 19. If Page is loaded separately, it suspends after Document starts
 * reading the PDF, which can cause React to remount Document. PDF.js has already transferred
 * the PDF data to its worker and detached the original buffer, so the remounted Document cannot
 * read it again. Later visits can appear to work because the lazy Page component is then cached.
 */
import { Suspense, lazy } from 'react';
import type { PdfDisplayProps } from './pdfDisplayImpl.tsx';

const PdfDisplayImpl = lazy(() => import('./pdfDisplayImpl.tsx'));


export function PdfDisplay(props: PdfDisplayProps) {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <PdfDisplayImpl {...props} />
        </Suspense>
    )
}
